export function toCommunityContentIdString(communityContentId) {
  let communityContentIdString = communityContentId.type + '-' + communityContentId.relatedId;
  if (communityContentId.secondaryRelatedId) {
    communityContentIdString += '-' + communityContentId.secondaryRelatedId;
  }

  return communityContentIdString;
}
